import { useState, useEffect } from 'react'
import { SellerCard, SellerGrid } from 'modules/sellers/components'
import type { FC } from 'react'
import { SellerService } from 'modules/sellers/services'
import parser from 'fazendinha/seller'
import { Seller } from 'framework/sellers'
import { useRouter } from 'next/router'
import { Pagination } from 'components/ui'
import { ROUTE_SELLER_INDEX } from 'routes/sellers'
import type { SellersViewProps } from '.'
import s from './sellers-view.module.css'

const SellersView: FC<SellersViewProps> = () => {
  const router = useRouter()
  const [sellers, setSellers] = useState<Array<Seller>>([] as unknown as Array<Seller>)
  const [lastPage, setLastPage] = useState<number>(1)

  useEffect(() => {
    async function getSellers() {
      const page = (router.query?.page as unknown as string) || '1'
      const sellerService = new SellerService()
      const sellerResponse = await sellerService.list({ page })
      setSellers(sellerResponse.data.data.map((seller: any) => parser(seller)) as unknown as Array<Seller>)
      setLastPage(sellerResponse.data.meta.last_page)
    }
    getSellers()
  }, [router])

  return (
    <>
      <SellerGrid>
        {sellers.map((seller) => (
          <SellerCard seller={seller} />
        ))}
      </SellerGrid>
      <div className={s.pagination}>
        {sellers.length > 0 && <Pagination href={ROUTE_SELLER_INDEX} total={lastPage} />}
      </div>
    </>
  )
}

export default SellersView
